/** localStorage key (via StorageService) of the "Remember me" data saved on login. */
export const LS_REMEMBER_ME_DATA_KEY = 'remember.me.data';

export interface RememberMeData {
  login: string;
  rememberMe: boolean;
}
